// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"480141bb","513":"c169e242","703":"ee903952"}[chunkId] + ".chunk.js";
};